import React from "react";

import { createRoot } from "react-dom/client";
import App from "./App";

class WebComponent extends HTMLElement {
  connectedCallback() {
    const props = {
      technologiesVocabularyId: this.getAttribute("TECHNOLOGIES_VOCABULARY_ID"),
      industriesVocabularyId: this.getAttribute("INDUSTRIES_VOCABULARY_ID"),
      structureId: this.getAttribute("STRUCTURE_ID"),
      clienId: this.getAttribute("CLIENT_ID"),
      clientSecret: this.getAttribute("CLIENT_SECRET"),
      grantType: this.getAttribute("GRANT_TYPE"),
    };

    createRoot(this).render(<App props={props} />);
  }
}

const ELEMENT_ID = "case-study";

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
